/** @jsxImportSource @emotion/react */
import MuiInput, { type InputProps } from '@mui/material/Input';
import React from 'react';

/**
 * Basic input component that wraps MUI's Input component with custom styles.
 * Can (and probably should) be used in conjunction with FormControl and
 * InputLabel components.
 *
 * Consider using the TextField component for a more complete input solution.
 */
export const Input = ({
  autoFocus,
  className,
  defaultValue,
  disabled,
  endAdornment,
  error,
  id,
  multiline,
  name,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  readOnly,
  required,
  rows,
  type,
  value,
}: Pick<
  InputProps,
  | 'autoFocus'
  | 'className'
  | 'defaultValue'
  | 'disabled'
  | 'endAdornment'
  | 'error'
  | 'id'
  | 'multiline'
  | 'name'
  | 'onBlur'
  | 'onChange'
  | 'onFocus'
  | 'placeholder'
  | 'readOnly'
  | 'required'
  | 'rows'
  | 'type'
  | 'value'
>) => (
  <MuiInput
    autoFocus={autoFocus}
    className={className}
    data-testid="nds-component-input"
    defaultValue={defaultValue}
    disabled={disabled}
    endAdornment={endAdornment}
    error={error}
    id={id}
    multiline={multiline}
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    onFocus={onFocus}
    placeholder={placeholder}
    readOnly={readOnly}
    required={required}
    rows={rows}
    type={type}
    value={value}
  />
);
